import { render, staticRenderFns } from "./PermissionRolesTable.vue?vue&type=template&id=62087b05"
import script from "./PermissionRolesTable.vue?vue&type=script&lang=js"
export * from "./PermissionRolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62087b05')) {
      api.createRecord('62087b05', component.options)
    } else {
      api.reload('62087b05', component.options)
    }
    module.hot.accept("./PermissionRolesTable.vue?vue&type=template&id=62087b05", function () {
      api.rerender('62087b05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/RolePermissions/PermissionRolesTable.vue"
export default component.exports